import { useState, useEffect } from 'react';
import { X, Sparkles } from 'lucide-react';
import { API, authFetch } from '@/App';

export default function DailyStatBanner({ onClose }) {
  const [stat, setStat] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStat();
  }, []);

  const fetchStat = async () => {
    try {
      const response = await authFetch(`${API}/stats/daily`);
      if (response.ok) {
        const data = await response.json();
        setStat(data);
      }
    } catch (error) {
      console.error('Error fetching daily stat:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !stat) return null;

  return (
    <div 
      data-testid="daily-stat-banner"
      className="mx-4 my-4 p-4 rounded-2xl fade-in relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, hsl(330, 85%, 65%) 0%, hsl(25, 95%, 65%) 100%)'
      }}
    >
      <button
        data-testid="close-stat-banner"
        onClick={onClose}
        className="absolute top-3 right-3 p-1.5 bg-white/20 hover:bg-white/30 rounded-full transition-colors"
      >
        <X className="w-4 h-4 text-white" />
      </button>
      
      <div className="flex items-start gap-3 pr-8">
        <div className="p-2 bg-white/20 rounded-full">
          <Sparkles className="w-5 h-5 text-white" />
        </div>
        <div>
          <h3 className="font-bold text-white mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Today's Glow Stat
          </h3>
          <p className="text-white/95 text-sm leading-relaxed">
            {stat.stat_text}
          </p>
        </div>
      </div>
    </div>
  );
}
